import startCase from 'lodash.startcase';

export const toTitleCase = (str: string = '') => {
  return startCase(str.toLowerCase());
};
